import Cookies from 'js-cookie';

/**
 * Logout function - clears all auth-related cookies and redirects to login
 */
export function logout() {
    // Clear all authentication cookies
    Cookies.remove('token');
    Cookies.remove('user');
    Cookies.remove('isLoggedIn');
    Cookies.remove('expiresIn');
    Cookies.remove('userid');

    // Redirect to login page
    if (typeof window !== 'undefined') {
        window.location.href = '/';
    }
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated() {
    const token = Cookies.get('token');
    const isLoggedIn = Cookies.get('isLoggedIn');
    return !!(token && isLoggedIn === 'true');
}

/**
 * Get current user data from cookies
 */
export function getCurrentUser() {
    try {
        const userStr = Cookies.get('user');
        return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
        console.error('Error parsing user data:', error);
        return null;
    }
}

/**
 * Get authentication token
 */
export function getToken() {
    return Cookies.get('token');
}
